var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmailDisconnected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0H2C.9 0 .01.9.01 2L0 14c0 1.1.9 2 2 2h8v-2H2V4l8 5 8-5v5h2V2c0-1.1-.9-2-2-2zm-8 7L2 2h16l-8 5z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.34l-1.42-1.42-2.12 2.13-2.12-2.13-1.42 1.42 2.13 2.12-2.13 2.12L14.34 18l2.12-2.13L18.58 18 20 16.58l-2.13-2.12L20 12.34z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "4ea1574b345cb89c25bf838bc300f82e.svg";
export { SvgEmailDisconnected as ReactComponent };